import React from 'react';
import styles from './OnlineLabel.module.scss';

type Props = {
  isOnline?: boolean
};

export const OnlineLabel: React.FC<Props> = ({ isOnline = false }) => {
  return (
    <div className={`${styles['online-label']} ${isOnline ? styles['online-label--online'] : ""}`} />
  );
};
